(function($) {
    'use strict';
    jQuery(document).ready(function($) {
        var offset = 0; // Kéo xuống khoảng cách 220px thì xuất hiện button
        var duration = 500; // THời gian di trượt là 0.5 giây 
        jQuery(window).scroll(function() {
            if (jQuery(this).scrollTop() > offset) {
                $(".enable-fixed").addClass('stick');
            } else {
                $(".enable-fixed").removeClass('stick');
            }
        });
      function readMore(string, maxWords) {       
        var strippedString = $("<p>" + string + "</p>").text().trim();      
        var array = strippedString.split(" ");
        var string = array.splice(0, maxWords).join(" ");

        if(array.length > maxWords) {
          string += "...";
        }

        return string ;
      }
      function convert_currency_andy(value, type) {
        var newCurrency = Currency.currentCurrency;
        if(Currency.currentCurrency=== undefined) newCurrency= 'EUR';
        var oldCurrency = shopCurrency;
        if (isNaN(value)) {
          value = 0.0;
        }
       
        var cents = 0.0;
        var oldFormat = Currency.moneyFormats['EUR'][Currency.format] || '';
        var newFormat = Currency.moneyFormats['EUR'][Currency.format] || '';
        if (oldFormat.indexOf('amount_no_decimals') !== -1) {
             cents = Currency.convert(parseInt(value, 10) * 100, oldCurrency, newCurrency);
        } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
             cents = Currency.convert(parseInt(value, 10) / 10, oldCurrency, newCurrency);
        } else {
             cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
        }
        if (type == 'nosymbol') {
          return cents; 
        }
        var my_data = Currency.formatMoney(cents, newFormat);
        return my_data;

      }
                                              
      function show_dropdown_cart(){
       
        $.ajax({
          url: ' /cart.js',
          type: 'GET', 
          dataType: 'json',
          success: function(data) {
            $("#cartCount").text(data.item_count);
            if (data.item_count > 0) {
              var html = '';
              html = html + '<h3 class="widget-title">Shopping Cart</h3>';
              html = html + '<div class="mcart-border">';
              html = html + '<ul class="cart-list">';
              $.each(data.items, function(index, el) {
                html = html + '<li id="item-'+el.id+'"> <a class="product-image" href="'+el.url+'"> <img src="' + el.image + '" alt="'+el.title+'"/><span class="quantity">'+el.quantity+'</span></a>';
                html = html + '<div class="product-details"> <a  data-id="'+el.id+'" class="remove small-cart-remove" title="Remove this item"> <i class="fa fa-times-circle"></i> </a>';
                html = html + '<a class="product-name" href="'+el.url+'"> ' + el.title + ' </a>';
                html = html + '<span class="quantity"> '+ convert_currency_andy(el.price) +' </span> </span>' + ' </div></li>';
              });
              html = html + '</ul><p class="total">Subtotal<span id="cartCost"></span></p>';
              html = html + '<p class="buttons"><a href="/checkout">Check Out</a><a href="/cart">view cart</a></p>';
              html = html + '<div>';

              $(".mini-cart-inner").html(html);
             
            }else{
              var html = '';
              html = html + '<h3 class="widget-title">You have no items in your shopping cart.</h3>';
              html = html + '<div class="mcart-border">';
              html = html + '<p class="buttons"><a style="width: 100%; border-left:1px solid #ccc;" href="/collections/all">Continue shopping</a></p>'
              html = html + '<div>';
              $(".mini-cart-inner").html(html);
            }
            
            
              $("#cartCost").html(convert_currency_andy(data.total_price ));
          }
        });
      }
      	$(".added-wishlist").hide();
        $(document).on('click',".wishlist", function(event) {
            var $this = $(this);
            event.preventDefault();
            /* Act on the event */
            var myid = $(this).data('form');
            var args = $("input[value='" + myid + "']").first().parent('form').serialize();
            $("#loading").show();
            $.ajax({
                url: '/contact',
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                        $this.hide(600).next('a.added-wishlist').show(700);
                        $("#loading").hide(500);
                        swal("Success!", "Added success to wishlist!", "success");
                    } else {
                        $("#loading").hide(500);
                        sweetAlert("Oops...", "Please login to use wishlist!", "error");
                    }
                }
            });
        });
        $(document).on('click',".wishlist-login", function(event) {
            event.preventDefault();
            /* Act on the event */
            sweetAlert("Oops...", "Please login to use wishlist!", "error");
        });
        $(document).on('click',".wishlist-addtocart", function(event) {
            event.preventDefault();
            /* Add product in wishlist to cart*/
            var $this = $(this);
            $("#loading").show();
            var value = $(this).data('wid');
            $('.product-select').val(value);
            var args = $('.add-variant').serialize();
            $.ajax({
                url: $('.add-variant').attr('action'),
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                  show_dropdown_cart();
                    if (status == "success") {
                        $this.hide(600).next('button.wishlist-addedtocart').removeClass('wishlist-addedtocart').show(700);
                        $("#loading").hide(500);
                        swal("Success!", "Added success to cart!", "success");
                    } else {
                        $("#loading").hide(500);
                        sweetAlert("Oops...", "An error occurred when add to cart!", "error");
                    }
                }
            });
        });
        $('.wishlist-remove').on('click', function(event) {
            event.preventDefault();
            $("#loading").show();
            /* Remove product from wishlist*/
            var $this = $(this);
            var value = $(this).data('wid');
            $('.remove-value').val(value);
            var args = $('.contact-form').serialize();
            $.ajax({
                url: $('.contact-form').attr('action'),
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                        $("tr." + value).slideUp(600);
                        $("#loading").hide(500);
                        swal({
                            title: "Auto close alert!",
                            text: "Remove success.",
                            timer: 2000,
                            showConfirmButton: false
                        });
                    } else {
                        $("#loading").hide(500);
                    }
                }
            });
        });
    /* Compare Product*/
    var storage = $.localStorage;
    var compare = {};
    var total_compare = 3;
    if (storage.isSet('compare')) {
      compare = storage.get('compare');
    } else {
      storage.set('compare', {});
    }
    function compare_to_table(data) {
      if (Object.keys(data).length <= 0) {
        return '';
      }
      var html = '';
      var i = 0;

      var end_check = (Object.keys(data).length - 1);
      var width_tr = (end_check > 0) ? (90 / (Object.keys(data).length)) : 90;
      var data_html = '';
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        data_html = data_html + '<th class=" ' + el.handle + '"><button type="button" class="close remove-compare center-block" aria-label="Close" data-handle="' + el.handle + '">Remove<span aria-hidden="true" class="remove-compare-x">&times;</span></button></th>';
        //Start title 
        if (i == 0) {
          html = html + '<tr >';
          html = html + '<th width="15%" class="product-name" > Product name </th>';
        }
        html = html + '<td width="' + width_tr + '%"  class="' + el.handle + '"> ' + el.title + '  </td>';
        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End Title 
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > Product image </th>';

        }
        // start product image
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + '"> <img src="' + el.featured_image + '"  width="150"/> ' + '<div class="product-price"> ';
        if (is_sale) {
          html = html + '<strong>On Sale</strong>' + '<span class="price-sale"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(el.price,'11')+'">'+convert_currency_andy(el.price,'11')+'</span></span>';
        } else {
          html = html + '<span class="price-sale"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(el.price,'11')+'">'+convert_currency_andy(el.price,'11')+'</span></span>';
        }
        if (convert_currency_andy(el.compare_at_price, 'nosymbol') > 0) {
          html = html + '<span class="visually-hidden">Regular price</span> <s>' + convert_currency_andy(el.compare_at_price, '11') + '</s>';
        }
        html = html + '</div>';
        //convert_currency(el.price,'3');
        if (el.variants.length > 1) {
          html = html + '<a href="#" onclick="location.href=\'/products/' + el.handle + '\'">Select Options</a>';
        } else {
          html = html + '<a href="#" title="Add to Cart" data-pid="' + el.variants[0].id + '" class="add-to-cart">Add to Cart</a>';
        }
        html = html + ' </td>';

        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End product image
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > Product description </th>';

        }
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + ' "> <p class="description-compare"> '+readMore(el.description,50)+' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > AVAILABILITY </th>';

        }

        var avai_stock = (el.available) ? 'Available In stock' : 'Unavailable In stock';
        html = html + '<td   width="' + width_tr + '%" class="available-stock ' + el.handle + '"> <p> ' + avai_stock + ' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      $(".th-compare").html('<td>Action</td>'+data_html);
      $("#table-compare").html(html);
    }
    if (!$.isEmptyObject(compare)) {
      var list_id = '';
      var json_compare = [];
      var check_end = 0;
      var compare_size = (Object.keys(compare).length - 1);
      $.each(compare, function(index, el) {
//         $("[data-pid='"+el+"']").addClass('added').text('Added to compare');
        var json_url = "/products/" + el + ".js";
        if ($.trim(el) != "") {
          jQuery.getJSON(json_url, function(product) {
            json_compare[check_end] = product;
            if (check_end >= compare_size) {
              $("#compare-sidebar .no-compare").hide();
              compare_to_table(json_compare);
            }
            check_end += 1;
          });

        }

      });
    } else {
      $(".error-compare").show();
    }
    function modal_compare(){
      if (!$.isEmptyObject(compare)) {
        // $(".error-compare").hide(20);
        var list_id = '';
        var json_compare = [];
        var check_end = 0;
        var compare_size = (Object.keys(compare).length - 1);
        $.each(compare, function(index, el) {
          var json_url = "/products/" + el + ".js";
          if ($.trim(el) != "") {
            jQuery.getJSON(json_url, function(product) {
              json_compare[check_end] = product;
              if (check_end >= compare_size) {
                compare_to_table(json_compare);
              }
              check_end += 1;
            });

          }

        });
        $("#moda-compare").modal('show');
      }
    }
    $(document).on('click', '.remove-compare', function(event) {
      event.preventDefault();
      /* Act on the event */

      var id = $(this).data('handle');

      $("." + id).fadeOut(600).remove();
      $.each(compare, function(index, el) {
        if (el == id) {
          compare[index] = "";
          delete compare[index];
        }
      });
      storage.set('compare', compare);
      //       swal({
      //         title: "Delete success",
      //         text: "I will close in 2 seconds.",
      //         timer: 2000,
      //         showConfirmButton: false,
      //         type: "success"
      //       });
    });
  
    $(document).on('click','.compare', function(event) {

      event.preventDefault();
      $("#loading").show();
      /* Act on the event */
      var $this = $(this);
      var pid = $(this).data('pid');

      compare = storage.get('compare');
      if ($.isEmptyObject(compare)) {
        compare = {};
      }
      var check_compare = true;
      if (Object.keys(compare).length >= total_compare) {
        swal({
          title: "info",
          text: "Product Added over 3 product !. Do you want go to compare page ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4cae4c",
          confirmButtonText: "Yes,I want view it!",
          timer: 5000,
          cancelButtonText: "Continue",
          closeOnConfirm: false
        },
             function() {
          window.location.href = 'https://' + Shopify.shop + '/pages/compare'
        });
      } else {
        for (var i = 1; i <= 3; i++) {
          if (compare['p' + i] == "" || compare['p' + i] == undefined) {
            compare['p' + i] = pid;
            break;
          } else if (compare['p' + i] == pid) {
            $this.addClass('added');
            check_compare = false;
            modal_compare(compare);

            break;
          }
        }
        if (check_compare) {
          storage.set('compare', compare);
          // swal("Success!", "Added success to compare!", "success");
          modal_compare(compare);
          $this.addClass('add-success');
        }
      }
      $("#loading").hide(500);
    });
    /** End compare */


        /**
         * Bx slider
         */
      
        var zoom_config = {
            cursor: 'pointer',
            galleryActiveClass: 'active',
            imageCrossfade: true,
            loadingIcon: "//cdn.shopify.com/s/global/lightbox/v2/loading.gif",
            zoomWindowFadeIn: 500,
            zoomLensFadeIn: 500,
            zoomWindowWidth: 200,
            zoomWindowHeight: 274,
            zoomWindowOffetx: 10,
            scrollZoom: false,
            responsive: true
        };
      var bx_slider;
        var bx_page;
        /**
         *  elevateZoom Zoom
         */
      //	$(".bxslider li:nth-of-type(1) img").elevateZoom(zoom_config);
        bx_slider = $('.bxslider').bxSlider({
            pagerCustom: '#bx-pager',
            controls:false,
            onSlideAfter: function($slideElement, oldIndex, newIndex) {
                $('.zoomContainer').remove();
               // $.removeData($(".bxslider li img"), 'elevateZoom');
              //  $(".bxslider li:nth-of-type(" + (newIndex + 2) + ") img").elevateZoom(zoom_config);
            }
        });
    
        
        bx_page = $("#ProductThumbs").bxSlider({
            slideWidth: 130,
            slideMargin: 11.5,
            minSlides: 4,
            maxSlides: 4,
            pager: false,
            speed: 500,
            pause: 3000,
          infiniteLoop: false
        });

        $(".bxslider-home").each(function(index, el) {
            $(this).bxSlider({
                pagerCustom: '#bx-pager-home' + index,
            });
        });
        $(".ProductThumbs-home").each(function(index, el) {
            $(this).bxSlider({
                slideWidth: 130,
                slideMargin: 11.5,
                minSlides: 4,
                maxSlides: 4,
                pager: false,
                speed: 500,
                pause: 3000
            });
        });

        /**
         * Quick view modal
         */
        $(".quick-view").on('click', function(event) {
            event.preventDefault();
            /* Act on the event */
            $("#loading").fadeIn(300);
            var url = $(this).attr('href');
            $("#quick-view-modal .modal-content").load(url + " #product-single", function() {
              $("#quick-view-modal").modal('show');
              var html = "";
              html = html + "<span class='adding'></span><span class='added'></span><span id='AddToCartText'>Add to Cart</span>";
              $("#quick-view-modal #AddToCart").html(html);
              setTimeout(function() {
                bx_slider = $('.bxslider').bxSlider({
                  pagerCustom: '#bx-pager',
                  controls:false,
                  onSlideBefore: function($slideElement, oldIndex, newIndex) {},
                  onSlideAfter: function($slideElement, oldIndex, newIndex) {
                    $('.zoomContainer').remove();
                  //  $.removeData($(".bxslider li img"), 'elevateZoom');
                  //  $(".bxslider li:nth-of-type(" + (newIndex + 2) + ") img").elevateZoom(zoom_config);
                  }
                });
                bx_page = $("#ProductThumbs").bxSlider({
                  slideWidth: 130,
                  slideMargin: 11.5,
                  minSlides: 4,
                  maxSlides: 4,
                  pager: false,
                  speed: 500,
                  pause: 3000
                    });
                   // $(".bxslider li:nth-of-type(2) img").elevateZoom(zoom_config);
                    $("#loading").hide();
                }, 200);
              
          $("#quick-view-modal #product-single .col-md-6.col-sm-12").removeClass('col-sm-12').addClass('col-sm-6 col-xs-12');
              
                  $('[data-toggle=\'tooltip\']').tooltip({
                    container: 'body'  
                  });
            });
        });
        /**
         * End quickview
         */
      /** Function display list all product in cart */

      function show_cart(data) {
        if (data.item_count > 0) {
          var html = '';
          $.each(data.items, function(index, el) {
            html = html + '<li> <h3 class="cart-title"> ' + el.title + '  </h3><div class="cart-image">';
            html = html + ' <img src="' + el.image + '" width="50" /> </div> ';
            html = html + ' <p> Price <strong> ' + el.price + ' </strong> </p>';
            html = html + ' <p> Quantity <strong> ' + el.quantity + ' </strong> </p></li>';
          });

          $("#quick-view-modal").modal('show');

          $("#quick-view-modal .modal-content").html(html);
          } else {
          sweetAlert("Oops...", "Cart is empty!", "error");
        }
      }
      
      $(document).on('click',".add-to-cart", function(event) {
        $(this).attr('disabled','disabled');
        $("#quick-view-modal #AddToCart span.added").css({'z-index': '0'});
        $("#quick-view-modal #AddToCart span.adding").css({'opacity':'1','z-index':'1','left':'40%'}).addClass('fa-2x fa fa-spinner fa-pulse');;
        $(".added-cart").css({'opacity':'1', 'transform':'rotate(360deg)'});
        $(".add-to-cart").css({'opacity':'.5'});
        event.preventDefault();
        var id= $("#productSelect").val();
        var quanlity =  $("#Quantity").val();
        if(jQuery.type(id) === "undefined"){
          id =    $(this).data('pid');
          quanlity = 1;
          }
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            quantity: quanlity,
            id: id
          },  
          success: function(response) {
            show_dropdown_cart();
            $('.add-to-cart').removeAttr("disabled");
            $("#quick-view-modal #AddToCart span.adding").removeClass('fa-spinner fa-pulse fa-2x').addClass('fa fa-check').css({'left':'86%'});
            $("#quick-view-modal #AddToACart span.added").css({'z-index': '-1'});
            $(".added-cart").css({'opacity':'0', 'transform':'rotate(0deg)'});
        	$(".add-to-cart").css({'opacity':'1'});
            $("#modal-cart").slideDown('500');
            $("#modal-added-image-cart img").attr('src',response.image);
            $("#modal-added-title-cart").text(response.title);
            var my_currency = Currency.moneyFormats.EUR;
            $("#modal-new-price").text(convert_currency_andy(response.price));
          }
        });
      });
      
      
      $(document).on('click',".small-cart-remove",function(event){
        event.preventDefault();
        var id = $(this).data('id');
       
        $.ajax({
          url:'/cart/update.js',
          type: 'POST', 
          dataType: 'json',
          data:"updates["+id+"]=0",
          success: function(data) {
        $("#cartCost").text(convert_currency_andy(data.total_price));
          $("#cartCount").text(data.item_count);
          
        	show_dropdown_cart();
        
          }
        });
         $("#item-"+id).remove();
       
      });
      
      $("#quick-view-modal button.close").on('click', function(){
        $('#modal-cart').remove();
      })
      $("#close-cart").on('click',function(){
        $("#modal-cart").slideUp('500');
      });
      
        /**
         * 
         * Countdown time
         */
        $(".timmer-event").each(function() {
            var event_time = $(this).data('datetime');
            $(this).countdown(event_time, function(event) {
                var $this = $(this).html(event.strftime('' + '<span class="weeks">%w</span> weeks ' + '<span class="days">%d</span> days ' + '<span class="hours">%H</span> hr ' + '<span class="mins">%M</span> min ' + '<span class="secs">%S</span> sec'));
            });
        });

        $('[data-toggle=\'tooltip\']').tooltip({
            container: 'body'
        });
      $(".rdcma-carousel-product").each(function(index,val){
        var col = parseInt($(this).data('items'));
        var single_item =false ;
        if( col <=1 ){
          single_item = true;
        }
        var item_desktop = (parseInt($(this).data('itemsdesktop'))> 1) ? (parseInt($(this).data('itemsdesktop')) -1)  : 1;
        $(this).owlCarousel({
          // Most important owl features
          items :  col,
          itemsCustom : false,
          itemsDesktop : [1199,parseInt($(this).data('itemsdesktop')) ],
          itemsDesktopSmall :[980,3],
          itemsTablet: [768,parseInt($(this).data('itemstablet'))],
          itemsTabletSmall: false,
          itemsMobile : [479,parseInt($(this).data('itemsmobile'))],
          singleItem :single_item ,
          itemsScaleUp : false,

          //Basic Speeds
          slideSpeed : parseInt($(this).data('slidespeed')),
          paginationSpeed :parseInt($(this).data('paginationspeed')),
          rewindSpeed : parseInt($(this).data('rewindspeed')),
          //  mouseDrag:false,
          //Autoplay
          autoPlay : $(this).data('autoplay'),
          stopOnHover : true,

          // Navigation
          navigation : $(this).data('navigation'),
          navigationText : ["prev","next"],
          rewindNav : true,
          scrollPerPage : false, 

          //Pagination
          pagination : $(this).data('pagination'),
          paginationNumbers: false,

          // Responsive 
          responsive: true,
          responsiveRefreshRate : 200,
          responsiveBaseWidth: window,

          // CSS Styles
          baseClass : "owl-carousel",
          theme : "owl-theme",
        })   
      });

    //Scroll top jquery
        $("#scroll-top").on('click', function(event) {
            event.preventDefault();
            /* Act on the event */
               $("html, body").animate({ scrollTop: 0 }, "slow");
        });
  
      $('.flexslider').flexslider();
	
       $("#slider-range").slider({ 
            range: true,
          	min: 20,
            max: 100,
            values: [20, 100],
            slide: function(event, ui) {
                $("#amount").val(Currency.currentCurrency +" " + ui.values[0] + " - "  + Currency.currentCurrency + " "+ ui.values[1]);
            },
            change: function(event, ui) {
                $("#loading").show(400);
                var max_price = ui.values[1];
                var min_price = ui.values[0];
                var check = 1;
                $("#list-product").html('');
          		var html = '';
          		var view =$(".change-view--active").data('view');
          
                $.each(json_collection_filter,function(index, elem) {
                    if (check <= 10) {
                        var current_price =  convert_currency_andy(elem.price,'');
                        current_price = parseInt(current_price.replace(/[^0-9.]/g, ''));
                        if (current_price <= max_price && current_price >= min_price) {
                              if(view  == 'list'){
                                html = html +    search_html(elem);
                              }else{
                                html = html +  search_grid(elem);
                              }
                            
                        }
                    }
                    check++;
                });
               
                $("#list-product").html(html);
                window.setTimeout(function() {
                  $("#loading").hide(400);
                  $(".pagination").remove();
                  $('[data-toggle=\'tooltip\']').tooltip({
                    container: 'body'  
                  });
                }, 1000);
        }
        });
        function search_html(data){
          var  is_sale = false;
          var $html ='';
            if(data.compare_at_price > data.price){is_sale =true};
          		$html = $html +  '<div class="item-list">';
            	$html = $html +  '<div class="col-md-5 col-sm-6 col-xs-12">';
          			$html = $html +  '<div class="image-container">';
                      if(is_sale){
                        $html = $html + '<div class="onsale"><span class="sale-bg"></span><span class="sale-text">Sale</span></div>';
                      }
                      $html = $html + '<a href="/products/'+data.handle+'" title="'+data.title+'">';
                      $html = $html + '<figure class="image-visible"><img src="'+data.images[0]+'" alt="'+data.title+'"></figure></a>';
          			$html = $html + '</div>';
          		$html = $html + '</div>';
          		$html = $html + '<div class="col-md-7 col-sm-6 col-xs-12 product-text">';
          			$html = $html + '<a href="/products/'+data.handle+'" title="'+data.title+'" class="product-link"><h2 class="product-name">'+data.title+'</h2></a>';
          			$html = $html + '<div class="product-price">';
                    if(convert_currency_andy(data.compare_at_price,'nosymbol') > 0){
                      $html = $html + '<span class="old-price">'+convert_currency_andy(data.compare_at_price,'11')+'</span>';
                      $html = $html + '<span class="special-price">'+convert_currency_andy(data.price,'11')+'</span>';
                    }else{
                      $html=$html+'<span class="price-sale">'+convert_currency_andy(data.price,'11')+'</span>';
                    }
                    $html = $html + '</div>';
                    $html = $html + '<div class="product-description">';
                    	$html = $html + '<p>'+readMore(data.description,50)+'</p>';
                    $html = $html + '</div>';
          			$html = $html + '<div class="action-area">';
          				$html = $html + '<div class="single-button">';
          				if((data.variants).length> 1){
          					$html = $html + '<a class="color-tooltip pd-options" title="Select Options" onclick="location.href=\'/products/'+data.handle+'\'">Select Options</a>';
                        }else{
                          	$html = $html + '<a class="color-tooltip add-to-cart" data-toggle="tooltip" title="" data-pid="11433608833" data-original-title="Add to Cart">Add to Cart</a>';
                        }
                   		$html = $html + '</div>';
                    $html = $html + '</div>';
          
          		$html = $html + '</div>';
            $html = $html + '</div>';
            return $html;
        }
        function search_grid(data){
          
          var  is_sale = false;
          if(data.compare_at_price > data.price){is_sale =true}
          var $html = '<div class="col-md-4 col-sm-6 col-xs-12"><div class="product-item"><div class="product-image">';
          if(is_sale){
            $html = $html + '<div class="onsale"><span class="sale-bg"></span><span class="sale-text">Sale</span></div>';
          }
          $html = $html + '<a href="/products/'+data.handle+'" title="'+data.title+'">';
          $html = $html + '<figure class="image-visible"><img src="'+data.images[0]+'" alt="'+data.title+'"></figure></a>';
          $html = $html + '<div class="product-overlay">';
          $html = $html + '<div class="action-button">';
          if((data.variants).length> 1){
            $html = $html + '<a class="color-tooltip pd-options" data-toggle="tooltip" title="Select Options" onclick="location.href=\'/products/'+data.handle+'\'" data-original-title="Select Options"><img src="//cdn.shopify.com/s/files/1/1135/1538/t/4/assets/icon-addtocart.png?412037345187555910"></a>';
          } else{
            $html = $html + '<a class="color-tooltip add-to-cart" data-toggle="tooltip" title="Add to Cart" data-pid="'+data.variants[0].id+'" data-original-title="Add to Cart"><img src="//cdn.shopify.com/s/files/1/1135/1538/t/4/assets/icon-addtocart.png?10150780104043957077"><span class="added-cart"></span></a>';
          }
          if(is_customers){
          	 $html +='<a class="wishlist color-tooltip" href="" data-pid="'+data.handle+'" title="Add to my wishlist"><img src="//cdn.shopify.com/s/files/1/1135/1538/t/4/assets/icon-wishlist.png?2702772200382315403" alt=""></a>';
             $html +='<a href="/collections/wishlist" class="added-wishlist color-tooltip" title="Added to wishlist" data-toggle="tooltip" data-placement="top" ><img src="//cdn.shopify.com/s/files/1/1135/1538/t/4/assets/icon-wishlist.png?2702772200382315403" alt=""></a>';
          }else{          
            $html = $html + '<a class="wishlist-login add_to_wishlist"   href="javascript:void(0)" title="Login to use wishlist" data-toggle="tooltip" data-placement="top"><img src="//cdn.shopify.com/s/files/1/1135/1538/t/4/assets/icon-wishlist.png?2702772200382315403" alt=""></a>';
          }
            
            $html = $html + '<a class="color-tooltip compare" data-toggle="tooltip" data-pid="'+data.title+'" title="Compare product" data-placement="top"><img src="//cdn.shopify.com/s/files/1/1135/1538/t/4/assets/icon-addcompare.png?2702772200382315403"></a>';
          
            
          $html = $html + '</div>';
          $html = $html + '</div>';
          $html = $html + '</div>';
          $html = $html + '<div class="product-text">';
          $html = $html + '<h2><a class="product-title" href="/products/'+data.handle+'" title="">'+data.title+'</a></h2>';
          $html = $html + '<div class="product-price">';
          $html = $html + '<a href="/products/'+data.handle+'" data-pid="'+data.variants[0].id+'" class="quick-view" title="Quick view">quickview</a>';
          if(convert_currency_andy(data.compare_at_price,'nosymbol') > 0){
            $html = $html + '<span class="old-price">'+convert_currency_andy(data.compare_at_price,'11')+'</span>';
            $html = $html + '<span class="special-price">'+convert_currency_andy(data.price,'11')+'</span>';
          }else{
            $html=$html+'<span class="price-sale">'+convert_currency_andy(data.price,'11')+'</span>';
          }
          $html = $html + '</div>';
          $html = $html + '</div></div></div>';

             return $html;
        }
        $("#amount").val(Currency.currentCurrency + " " + $("#slider-range").slider("values", 0) + " - " + Currency.currentCurrency +" "+ $("#slider-range").slider("values", 1));
    });
})(jQuery);
